import React, { useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { Block } from '../../layouts';
import { TextCommon } from '../../typo';
import { useAtom } from 'jotai';
import './InputPhone.scss';
import { currentLocaleState } from '../../../state/currentLocale';

const phoneUtil = PhoneNumberUtil.getInstance();

interface PhoneProps {
    nationalNumber: string;
    countryCode?: string;
    handlePhoneChange?: (countryCode: string, nationalNumber: string) => void;
    placeholder?: string;
    errorMessage?: string;
    disabled?: boolean;
}

const getInitialPhone = (
    nationalNumber: string,
    countryCode?: string,
    defaultCountry?: string
) => {
    let finalCountryCode = countryCode;

    if (!finalCountryCode && defaultCountry) {
        try {
            const exampleNum = phoneUtil.getExampleNumber(defaultCountry.toUpperCase());
            finalCountryCode = `${exampleNum.getCountryCode()}`;
        } catch {
            finalCountryCode = '';
        }
    }

    if (finalCountryCode) {
        return `${finalCountryCode}${nationalNumber}`;
    }

    return '';
};

export const InputPhoneNumber = (props: PhoneProps) => {
    const [currentLocale] = useAtom(currentLocaleState);
    const [fullPhone, setFullPhone] = useState(getInitialPhone(props.nationalNumber, props.countryCode, currentLocale?.country));
    const [isValid, setIsValid] = useState(true);

    const handlePhoneChange = (value: string) => {
        setFullPhone(value);

        try {
            const parsed = phoneUtil.parseAndKeepRawInput(value);
            const valid = phoneUtil.isValidNumber(parsed);
            props.handlePhoneChange?.(`${parsed.getCountryCode()}`, parsed.getNationalNumber()?.toString() || '');
            setIsValid(valid);
        } catch (error) {
            setIsValid(false);
        }
    };

    return (
        <Block>
            <PhoneInput
                defaultCountry={currentLocale?.country}
                value={fullPhone}
                onChange={handlePhoneChange}
                placeholder={props.placeholder}
                disabled={props?.disabled}
            />

            {!isValid && fullPhone && (
                <TextCommon color='#ff9800'>
                    {props.errorMessage}
                </TextCommon>
            )}
        </Block>
    );
};
